export default __webpack_public_path__ + "static/media/MP0052.a933d074.jpg";